exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".confirm__reset__error {\n  color: red;\n  text-align: center;\n  margin-top: 24px; }\n\n.confirm__reset__submit {\n  margin-top: 40px !important;\n  width: 100%; }\n\n.confirm__reset__success {\n  color: green;\n  text-align: center;\n  margin-top: 24px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Authentication/ConfirmResetForm/index.scss
// module id = 917
// module chunks = 1